// extracted by mini-css-extract-plugin
export var modal = "Modal-module--modal--hupZC";
export var modalClose = "Modal-module--modalClose--h+g15";
export var modalInner = "Modal-module--modalInner--0OFFn";
export var modalCloseBtn = "Modal-module--modalCloseBtn--mZ0x3";